import { ContentAdd } from '@fs/zion-icon/dist/cjs/icons'
import { useOverlay, Button } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import FamousCreatePersonDialog from './famous/FamousCreatePersonDialog'
import HistoricalCreatePersonDialog from './historical/HistoricalCreatePersonDialog'

export default function CreatePersonButton({ category, countries }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <>
      <Button Icon={ContentAdd} onClick={overlay.handleClick} emphasis="high">
        {t('action.create', 'Create')}
      </Button>
      {category === 'famous' && <FamousCreatePersonDialog countries={countries} {...overlay} />}
      {category === 'historical' && <HistoricalCreatePersonDialog countries={countries} {...overlay} />}
    </>
  )
}
